import React, { useMemo, useState, useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import Link from 'next/link';
import MiniCart from '~/components/shared/headers/modules/MiniCart';
import AccountQuickLinks from '~/components/shared/headers/modules/AccountQuickLinks';

const HeaderActions = () => {
    const compareItems  = useSelector(({ ecomerce }) => ecomerce.compareItems);
    const wishlistItems = useSelector(({ ecomerce }) => ecomerce.wishlistItems);
    const isLoggedIn    = useSelector(({ user }) => user.isLoggedIn);

    const compareTotal  = compareItems.length;
    const wishlistTotal = wishlistItems.length;

    const [pulseWishlistCount, setPulseWishlistCount] = useState(false);
    const [pulseCompareCount,  setPulseCompareCount]  = useState(false);

    const prevWishlistTotalRef = useRef(0);
    const prevCompareTotalRef  = useRef(0);
    const isInitialMountRef    = useRef(true);

    useEffect(() => {
        if (isInitialMountRef.current) {
            prevWishlistTotalRef.current = wishlistTotal;
            prevCompareTotalRef.current  = compareTotal;
            isInitialMountRef.current    = false;
            return;
        }

        if (compareTotal > prevCompareTotalRef.current) {
            setPulseCompareCount(true);
            setTimeout(() => setPulseCompareCount(false), 500);
        }
        prevCompareTotalRef.current = compareTotal;

        if (wishlistTotal > prevWishlistTotalRef.current) {
            setPulseWishlistCount(true);
            setTimeout(() => setPulseWishlistCount(false), 500);
        }
        prevWishlistTotalRef.current = wishlistTotal;

    }, [compareTotal, wishlistTotal]);

    const headerAuthContent = useMemo(() => {
        return <AccountQuickLinks isLoggedIn={true} />;
    }, [isLoggedIn]);

    return (
        <div className="header__actions">
            <div className="header__left">
                <div className="header__extra_container">
                    <Link
                        href="/account/compare"
                        className="header__extra"
                        aria-label="Vergleichen-Liste öffnen"
                    >
                        <i className="icon-chart-bars" aria-hidden="true" />
                        <span className={`count-badge ${pulseCompareCount ? 'pulse' : ''}`}>
                            <i>{compareTotal}</i>
                        </span>
                    </Link>
                    <div className="header__extra_text">
                        <span>Vergleichen</span>
                    </div>
                </div>

                <div className="header__extra_container">
                    <Link
                        href="/account/wishlist"
                        className="header__extra"
                        aria-label="Merkliste öffnen"
                    >
                        <i className="icon-heart" aria-hidden="true" />
                        <span className={`count-badge ${pulseWishlistCount ? 'pulse' : ''}`}>
                            <i>{wishlistTotal}</i>
                        </span>
                    </Link>
                    <div className="header__extra_text">
                        <span>Merkliste</span>
                    </div>
                </div>

                <MiniCart />
            </div>

            <div className="header__right">
                {headerAuthContent}
            </div>

            <style jsx>{`
                .header__actions {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    position: relative;
                }
                .header__left {
                    display: flex;
                    align-items: center;
                }
                .header__right {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    z-index: 10;
                }
                .header__extra_container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    margin-right: 20px;
                }
                .header__extra {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                }
                .header__extra_text {
                    margin-top: 5px;
                    font-size: 12px;
                    text-align: center;
                }
                .count-badge {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    background: #ff6b6b;
                    color: white;
                    font-weight: bold;
                    font-size: 12px;
                    margin-top: 2px;
                    line-height: 1;
                }
                .count-badge i {
                    font-style: normal;
                }
                .count-badge.pulse {
                    animation: pulse 0.5s ease-in-out;
                }
                @keyframes pulse {
                    0%   { transform: scale(1); }
                    50%  { transform: scale(1.5); }
                    100% { transform: scale(1); }
                }
                .ps-block--user-header {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 10;
                }
                .ps-block__left {
                    margin-right: 15px;
                }
                .ps-block__right a {
                    margin-left: 10px;
                }
                :global(.ps-cart--mini) {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    height: 100%;
                }
                :global(.ps-cart__content::before) {
                    content: '';
                    position: absolute;
                    bottom: 100%;
                    left: 0;
                    width: 100%;
                    height: 40px;
                    background-color: transparent;
                    z-index: 100;
                }
            `}</style>
        </div>
    );
};

export default HeaderActions;